import { __assign } from "tslib";
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as actionCreators from '../actionCreators';
import Comments from '../components/Comments';
import onlyIf from '../hocs/onlyIf';
import { isInHandoffMode } from '../selectors/handoff';
import { getIsCommentingEnabled } from '../selectors/project';
function mapStateToProps(state) {
    return {
        areCommentsVisible: state.comment.areVisible,
        commentCount: state.comment.count,
        notification: state.comment.notification,
        isCommentingEnabled: getIsCommentingEnabled(state),
        isHandoffOpen: isInHandoffMode(state),
    };
}
function mapDispatchToProps(stateProps, _a, ownProps) {
    var dispatch = _a.dispatch;
    var toggleComments = function () {
        if (stateProps.areCommentsVisible) {
            dispatch(actionCreators.hideComments());
        }
        else {
            dispatch(actionCreators.showComments());
        }
    };
    var hideHandoff = function () {
        if (stateProps.isHandoffOpen) {
            dispatch(actionCreators.hideHandoff());
        }
    };
    var props = {
        onNotificationClick: function () {
            hideHandoff();
            dispatch(actionCreators.hideCommentNotification());
            toggleComments();
            dispatch(actionCreators.setLeaveCommentPopoverCookie());
        },
        onCommentButtonClick: function () {
            hideHandoff();
            dispatch(actionCreators.hideCommentNotification());
            toggleComments();
            dispatch(actionCreators.setLeaveCommentPopoverCookie());
        },
    };
    return __assign(__assign(__assign({}, ownProps), stateProps), props);
}
var IsCommentingEnabled = function (props) { return props.isCommentingEnabled; };
export default compose(connect(mapStateToProps, null, mapDispatchToProps), onlyIf(IsCommentingEnabled))(Comments);
